import { render, staticRenderFns } from "./HotelPage.vue?vue&type=template&id=9cc8023a&"
import script from "./HotelPage.vue?vue&type=script&lang=ts&"
export * from "./HotelPage.vue?vue&type=script&lang=ts&"
import style0 from "./HotelPage.vue?vue&type=style&index=0&id=9cc8023a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports